import { render } from "./detailDialog.vue?vue&type=template&id=47bd39fe&scoped=true"
import script from "./detailDialog.vue?vue&type=script&lang=js"
export * from "./detailDialog.vue?vue&type=script&lang=js"

import "./detailDialog.vue?vue&type=style&index=0&id=47bd39fe&scoped=true&lang=scss"
import "./detailDialog.vue?vue&type=style&index=1&id=47bd39fe&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bd39fe"]])

export default __exports__